import React, { useEffect, useState } from "react";
import "./PopupModal.css";

export default function PopupModal() {
  const [show, setShow] = useState(false);

  // Show popup every time page loads
  useEffect(() => {
    setShow(true);
  }, []);

  const closePopup = () => {
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="popup-overlay" onClick={closePopup}>
      <div
        className="popup-container-"
        onClick={(e) => e.stopPropagation()}  // prevent close when clicking inside
      >
        {/* <img src="./images/popup.png" alt="Makreri Temple"  style={{width:'100%'} }/> */}
        <div style={{background:'white',padding:'25px',borderRadius:'6pt',border:'6px solid orange'}}>
          <br />
          <h3 style={{fontSize:'15pt',fontWeight:'600',color:'black'}}>Instruction for menithulapayasam, Palpayasam Collection</h3>
          <table className="table table-bordered">
            <tr>
              <td>Collecting Time </td>
              <td><span style={{fontSize:'12pt',fontWeight:'600'}}>8.30 am to 10.30 am</span></td>
            </tr>
            <tr>
              <td>Collecting Place</td>
              <td>Inside the Temple, Palpayasappura (North Nada) </td>
            </tr>
            <tr>
              <td>Note </td>
              <td>Bring your own vessels </td>
            </tr>
          </table>
        </div>


        <button className="close-btn" onClick={closePopup}>
          X
        </button>
      </div>
    </div>
  );
}
